import React from "react";
import "./CosmicBackground.css";

const CosmicBackground = () => {
  return <div className="cosmic-background" />;
};

export default CosmicBackground;
